import React from "react";
import T from "prop-types";
import {
  form,
  Form as AppForm,
  RadioGroupField
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { requestVendorRma } from "MODULES/RepairOrders/actions";
import {
  PARTIAL_CREDIT,
  RMA_REQUEST_TYPE
} from "MODULES/RepairOrders/constants";
import { properCase } from "LIB/formatters/text";
import { Warning } from "MODULES/shared/components";
import CurrencyField from "../../../../../../shared/components/Forms/CurrencyField";

function Form(props) {
  return (
    <AppForm {...props} buttonText="Continue">
      <AppForm.Body>
        <FormRow>
          <Col md={12}>
            <Field
              name={RMA_REQUEST_TYPE}
              label="Request Type"
              component={RadioGroupField}
              options={[
                {
                  value: "rma",
                  text: "Request RMA"
                },
                { value: PARTIAL_CREDIT, text: "Request Partial Credit" }
              ]}
            />
          </Col>
        </FormRow>
        {props.rmaRequestType === PARTIAL_CREDIT && (
          <FormRow>
            <Col md={6}>
              <Field
                component={CurrencyField}
                name={PARTIAL_CREDIT}
                label={properCase(PARTIAL_CREDIT)}
              />
            </Col>
          </FormRow>
        )}
        <FormRow>
          <Col md={12}>
            <Warning>
              This action sends a notification to QC requesting they begin the
              Vendor RMA or Partial Credit Request process. Are you sure you
              want to continue?
            </Warning>
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

const formName = "requestVendorRmaForm";
const selector = formValueSelector(formName);

export default connect(
  state => ({
    rmaRequestType: selector(state, RMA_REQUEST_TYPE)
  }),
  (dispatch, ownProps) => ({
    onSubmit: data => {
      toastr.success("Success", "Vendor RMA Requested");
      dispatch(requestVendorRma(ownProps.lineItem.id, data, ownProps.close));
    }
  })
)(
  form({
    form: formName
  })(Form)
);

Form.propTypes = {
  approveROLineItem: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/RequestVendorRma/Form.jsx